import { createContext, useState, useContext, useEffect } from 'react';

const TrincoContext = createContext();


export const TrincoProvider = ({ children }) => {
  const [codUsuario, setCodUsuario] = useState(localStorage.getItem('cod_usuario_anaki'));
  const [nomeUsuario, setNomeUsuario] = useState(localStorage.getItem('nome_usuario_anaki'));


  return (
    <TrincoContext.Provider value={{
      codUsuario, setCodUsuario,
      nomeUsuario, setNomeUsuario,
    }}>
      {children}
    </TrincoContext.Provider >
  );
};

export const useTrincoContext = () => useContext(TrincoContext);
